import { useState } from "react";
import { Redirect, useParams } from "react-router-dom";
import { PageHeaderWithBack } from "../../../Components/Molecules";
import { useAuth } from "../../../Contexts/AuthContext";
import { CrossborderCustomerSidebar } from "./components/CrossborderCustomerSidebar";
import { CrossborderCustomerTabContent } from "./components/CrossborderCustomerProfileTab";
import { CrossborderKycOnboardingModal } from "./components/CrossborderKycOnboardingModal";
import { CrossborderKycStatusBadge } from "./components/CrossborderKycStatusBadge";
import {
  CROSSBORDER_CUSTOMERS_PATH,
  getCountry,
  getCustomer,
  getCustomerProfile,
} from "./constants";

export const CrossborderCustomerProfile = () => {
  const { isReadOnly } = useAuth();
  const { customerId } = useParams();
  const customer = getCustomer(customerId);
  const profile = getCustomerProfile(customerId);
  const [activeTab, setActiveTab] = useState("profile");
  const [kycModalOpen, setKycModalOpen] = useState(false);

  if (!customer) {
    return <Redirect to={CROSSBORDER_CUSTOMERS_PATH} />;
  }

  const country = getCountry(customer.countryCode);

  return (
    <div className="w-full">
      <PageHeaderWithBack
        title={customer.label}
        subTitle={country?.label ?? ""}
        backTo={CROSSBORDER_CUSTOMERS_PATH}
      />

      <div className="mb-4 flex flex-wrap items-center gap-2">
        <CrossborderKycStatusBadge status={customer.kycStatus} />
        <span className="text-xs text-gray-500 dark:text-gray-400">{customer.email}</span>
      </div>

      <div className="grid grid-cols-1 gap-5 lg:grid-cols-[220px_minmax(0,1fr)]">
        <aside className="app-card p-3">
          <CrossborderCustomerSidebar customer={customer} activeTab={activeTab} onTabChange={setActiveTab} />
        </aside>

        <main className="min-w-0">
          <CrossborderCustomerTabContent
            activeTab={activeTab}
            customer={customer}
            profile={profile}
            onStartKyc={isReadOnly ? undefined : () => setKycModalOpen(true)}
            canMutate={!isReadOnly}
          />
        </main>
      </div>

      {!isReadOnly ? (
        <CrossborderKycOnboardingModal
          open={kycModalOpen}
          onClose={() => setKycModalOpen(false)}
          customer={customer}
          profile={profile}
          onComplete={() => setKycModalOpen(false)}
        />
      ) : null}
    </div>
  );
};
